import { useParams } from "react-router-dom";
import { FxmsData } from "../../fxms/datas/FxData";
/**
 * @description 오늘날짜 가져오기
 * @author seoeunPark
 * @date 06/12/2023
 * @param {"yyyymmdd" | "yyyymm" | "yyyy" | "mm"} 원하는 형식 택1
 * @return "yyyymmdd" | "yyyymm" | "yyyy" | "mm"
 */
export const getToday = (param) => {
  var date = new Date();
  var year = date.getFullYear();
  var month = ("0" + (1 + date.getMonth())).slice(-2);
  var day = ("0" + date.getDate()).slice(-2);

  if (param === "yyyymmdd") {
    return year + month + day;
  } else if (param === "yyyymm") {
    return year + month;
  } else if (param === "yyyy") {
    return year;
  } else if (param === "mm") {
    return month;
  } else {
    return year + month + day;
  }
};

/**
 * @description 전월(mm) 가져오기
 * @author seoeunPark
 * @date 06/12/2023
 * @param {"yyyymm" | "mm"} 원하는 형식 택1
 * @return "yyyymm" | "mm" (전월)
 */
export const getPrevMonth = (param) => {
  var date = new Date();
  var year = date.getFullYear();
  var month = date.getMonth() + 1;
  var prevMonth = month - 1;

  // 현재 월이 1월인 경우 처리 로직
  if (prevMonth === 0) {
    year -= 1;
    prevMonth = 12;
  }

  if (param === "yyyymm") {
    return year + ("0" + prevMonth).slice(-2);
  } else if (param === "mm") {
    return ("0" + prevMonth).slice(-2);
  } else {
    return year + ("0" + prevMonth).slice(-2);
  }
};

/**
 * @description 전날짜(yyyymmdd) 가져오기
 * @author seoeunPark
 * @date 06/12/2023
 * @param "20231231"
 * @return "20231230"
 */
export const getYesterday = (dateString) => {
  const year = dateString.substring(0, 4);
  const month = Number(dateString.substring(4, 6));
  const day = Number(dateString.substring(6, 8));

  const date = new Date(year, month - 1, day);
  date.setDate(date.getDate() - 1);

  const yearStr = date.getFullYear();
  const monthStr = ("0" + (date.getMonth() + 1)).slice(-2);
  const dayStr = ("0" + date.getDate()).slice(-2);
  return yearStr + monthStr + dayStr;
};

/**
 * @description 오름차순
 * @author seoeunPark
 * @date 06/12/2023
 * @param {*}
 * @return
 */
export const dataSort = (arr, propertyName = null) => {
  arr.sort(function (a, b) {
    if (propertyName) {
      return a.propertyName - b.propertyName;
    } else {
      return a - b;
    }
  });
};

/**
 * @description get complexInloNo
 * @author seoeunPark
 * @date 06/12/2023
 * @param {*}
 * @return complexInloNo
 */
export const MyCompInloNo = (props) => {
  const { complexInloNo } = useParams();

  if (complexInloNo === undefined) {
    return props.complexInloNo;
  }
  return complexInloNo;
};

/**
 * @description Icon 이미지 가져오기
 * @author seoeunPark
 * @date 06/12/2023
 * @param {*}
 * @return 아이콘 이미지
 */
export const getIcon = (x) => {
  let icon = "steam_icon.png";
  if (x === "AIR") {
    icon = "air_icon.png";
  } else if (x === "COOLWATER") {
    icon = "water_icon.png";
  } else if (x === "STEAM") {
    icon = "steam_icon.png";
  } else if (x === "ELEC") {
    icon = "elec_icon001.png";
  } else if (x === "EPWR") {
    icon = "epwr_icon.png";
  } else if (x === "NET") {
    icon = "net_icon.png";
  }
  return "../" + icon;
};

export const getEnergyDataList = (data, engId) => {
  let engList = FxmsData.getDatas("energy");
  let engDataLists = {};
  dataSort(data, "psDate");

  if (engId != null) {
    engDataLists[engId] = data.filter((i) => i.engId === engId);
  } else {
    for (let e of engList) {
      let engDataList = data.filter((i) => i.engId === e.engId);
      if (engDataList.length != 0) {
        engDataLists[e.engId] = engDataList;
        engDataLists[e.engId].engName = e.engName;
      }
    }
  }
  return engDataLists;
};

export const getArrOfDay = (arr, date) => {
  let result = [];
  if (arr.length != 0) {
    result = arr.filter((obj) => obj.psDate.toString().substr(0, 8) === date);
  }
  return result;
};

export const engUsageValSum = (arr) => {
  let result = arr.reduce((prev, curr) => {
    const { engId, consUsageVal, yyyymm } = curr;
    if (prev[engId]) {
      prev[engId].consUsageVal += parseInt(consUsageVal) || 0;
    } else {
      prev[engId] = {
        engId,
        consUsageVal: parseInt(consUsageVal) || 0,
        yyyymm: yyyymm,
      };
    }
    return prev;
  }, []);
  return result;
};
